/* TITANIOVA Maison V2 · JS léger, sans dépendance */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.TM && TM.root ? TM.root : '/').replace(/\/$/, '');
  const url = (p) => root + p;

  function money(cents) {
    const fmt = (window.TM && TM.moneyFormat) || '€{{amount_with_comma_separator}}';
    const n = (cents / 100).toFixed(2);
    const comma = n.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, comma.split(',')[0])
              .replace(/\{\{\s*amount\s*\}\}/, n)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, n.split('.')[0]);
  }
  function tr(t) {
    return (t || '').replace('Tamanho', 'Misura').replace('Pack 2 frigideiras', 'Duo · 2 padelle')
      .replace('Pack 3 frigideiras', 'Trio · 3 padelle').replace('Pack 2 padelle', 'Duo · 2 padelle').replace('Pack 3 padelle', 'Trio · 3 padelle').replace('1 frigideira', '1 padella')
      .replace(/frigideiras/g, 'padelle').replace(/frigideira/g, 'padella').replace('Default Title', '');
  }

  /* Panneaux (menu, panier) */
  function open(name) {
    const p = $(`[data-tm-panel="${name}"]`);
    if (!p) return false;
    p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false'); document.body.classList.add('tm-lock');
    return true;
  }
  function closeAll() {
    $$('[data-tm-panel].is-open').forEach((p) => { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('tm-lock');
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-tm-open]');
    if (o) {
      const n = o.getAttribute('data-tm-open');
      if (n === 'cart') { e.preventDefault(); refreshCart().then(() => open('cart')); return; }
      e.preventDefault(); open(n); return;
    }
    if (e.target.closest('[data-tm-close]')) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* Panier */
  const GIFTS = (window.TM && TM.gifts) || [];
  const giftIds = GIFTS.reduce((a, g) => a.concat(g.lid ? Object.values(g.lid) : [g.id]), []);
  const getCart = () => fetch(url('/cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const SD = (window.TM && TM.setDiscount) || null;
  const post = (path, body) => fetch(url(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  async function syncDiscount(cart) {
    if (!SD) return cart;
    const n = cart.items.filter((i) => SD.products.includes(i.product_id)).reduce((a, i) => a + i.quantity, 0);
    const want = n >= 3 ? SD.t2 : n >= 2 ? SD.t1 : '';
    const have = (cart.discount_codes || []).map((d) => d.code.toUpperCase()).filter((c) => c === SD.t1 || c === SD.t2);
    if ((want && !(have.length === 1 && have[0] === want)) || (!want && have.length)) {
      const r = await post('/cart/update.js', { discount: want });
      if (r.ok) cart = await r.json();
    }
    cart._setN = n;
    return cart;
  }
  async function syncGifts(cart) {
    cart = await syncDiscount(cart);
    let changed = false;
    const paid = () => cart.items.filter((i) => !giftIds.includes(i.variant_id));
    for (const g of GIFTS) {
      const sub = paid().reduce((a, i) => a + i.final_line_price, 0);
      let wantId = null;
      if (g.lid) {
        // couvercle offert à la taille de la plus grande poêle du panier
        let size = 0;
        paid().filter((i) => g.needs.includes(i.product_id)).forEach((i) => {
          const fx = g.fixed && g.fixed[String(i.product_id)];
          const nums = fx ? [+fx] : ((i.variant_title || '').match(/\b(2[0-9]|3[0-9])\b/g) || []).map(Number);
          nums.forEach((n) => { if (n > size) size = n; });
        });
        if (size) { const keys = Object.keys(g.lid).map(Number).sort((a, b) => a - b); const k = keys.reduce((best, x) => (x <= size ? x : best), keys[0]); wantId = g.lid[String(size)] || g.lid[String(k)]; }
      } else if (sub >= g.min) wantId = g.id;
      const ids = g.lid ? Object.values(g.lid) : [g.id];
      for (const id of ids) {
        const line = cart.items.findIndex((i) => i.variant_id === id);
        const want = id === wantId;
        let did = false;
        if (want && line < 0) { const r = await post('/cart/add.js', { items: [{ id, quantity: 1, properties: { _omaggio: '1' } }] }); did = r.ok; }
        else if (!want && line > -1) { await post('/cart/change.js', { id: cart.items[line].key, quantity: 0 }); did = true; }
        else if (want && line > -1 && cart.items[line].quantity > 1) { await post('/cart/change.js', { id: cart.items[line].key, quantity: 1 }); did = true; }
        if (did) { changed = true; cart = await getCart(); }
      }
    }
    cart._sub = paid().reduce((a, i) => a + i.final_line_price, 0);
    cart._changed = changed;
    return cart;
  }
  function giftBar(sub) {
    const GIFTS = ((window.TM && TM.gifts) || []).filter((g) => g.min);
    if (!GIFTS.length) return '';
    const next = GIFTS.find((g) => sub < g.min);
    const top = GIFTS[GIFTS.length - 1].min;
    const pct = Math.min(100, Math.round((sub / top) * 100));
    const marks = GIFTS.map((g) => `<span class="tm-gift__mark${sub >= g.min ? ' is-on' : ''}" style="left:${Math.round((g.min / top) * 100)}%"></span>`).join('');
    const msg = next ? `Ti mancano <b>${money(next.min - sub)}</b> per ricevere <b>${next.label} in omaggio</b>` : `<b>Complimenti:</b> i tuoi omaggi sono nel carrello`;
    const list = GIFTS.map((g) => `<li class="${sub >= g.min ? 'is-on' : ''}">${money(g.min)} · ${g.label} in omaggio</li>`).join('');
    return `<p class="tm-gift__msg">${msg}</p><div class="tm-gift__track"><span class="tm-gift__fill" style="width:${pct}%"></span>${marks}</div><ul class="tm-gift__list">${list}</ul>`;
  }
  async function refreshCart() {
    let cart = await getCart();
    cart = await syncGifts(cart);
    renderCart(cart);
    return cart;
  }
  window.TMrefreshCart = refreshCart;
  function renderCart(cart) {
    $$('[data-tm-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    const lab = $('[data-tm-count-label]'); if (lab) lab.textContent = cart.item_count ? `(${cart.item_count})` : '';
    const items = $('[data-tm-items]'); const empty = $('[data-tm-empty]'); const foot = $('[data-tm-foot]');
    if (!items) return;
    if (!cart.item_count) { items.innerHTML = ''; empty.hidden = false; foot.hidden = true; return; }
    empty.hidden = true; foot.hidden = false;
    const gb = $('[data-tm-gifts]'); if (gb) gb.innerHTML = giftBar(cart._sub || 0);
    items.innerHTML = cart.items.map((it, i) => {
      const gift = giftIds.includes(it.variant_id);
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160_crop_center$1$2') : '';
      const v = it.product_has_only_default_variant ? '' : tr(it.variant_title || '');
      return `<div class="tm-dline">
        <a href="${it.url}">${img ? `<img src="${img}" alt="" width="76" height="76" loading="lazy">` : ''}</a>
        <div><p class="tm-dline__name">${it.product_title}</p>${v ? `<p class="tm-dline__var">${v}</p>` : ''}
          ${gift ? '<span class="tm-giftpill">Omaggio</span>' : `<div class="tm-step"><button type="button" data-q="${i + 1}" data-n="${it.quantity - 1}" aria-label="Meno">−</button><span>${it.quantity}</span><button type="button" data-q="${i + 1}" data-n="${it.quantity + 1}" aria-label="Più">+</button></div>`}</div>
        <p class="tm-dline__price">${gift ? 'Gratis' : money(it.final_line_price)}</p></div>`;
    }).join('');
    const tot = $('[data-tm-total]'); if (tot) tot.textContent = money(cart.total_price);
    const dr = $('[data-tm-disc]');
    if (dr) { const d = (cart.items || []).reduce((a, i) => a + (i.original_line_price - i.final_line_price), 0) + (cart.cart_level_discount_applications || []).reduce((a, x) => a + x.total_allocated_amount, 0); dr.hidden = d <= 0; const dv = $('[data-tm-disc-v]'); if (dv) dv.textContent = '−' + money(d); }
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('.tm-step button[data-q]');
    if (!b) return;
    await fetch(url('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +b.dataset.q, quantity: Math.max(0, +b.dataset.n) }) });
    await refreshCart();
  });
  async function addItems(items, btn) {
    if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; btn.innerHTML = 'Aggiunto…'; }
    try {
      const r = await fetch(url('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); alert(j.description || 'Impossibile aggiungere al carrello.'); }
      await refreshCart(); open('cart');
    } finally {
      if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.label; }
    }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tm-addmany]');
    if (!b) return;
    e.preventDefault();
    const items = b.dataset.tmAddmany.split(',').filter(Boolean).map((x) => { const [id, q] = x.split(':'); return { id: +id, quantity: +(q || 1) }; });
    addItems(items, b);
  });

  /* Compte à rebours (offre saisonnière datée) */
  const cds = $$('[data-tm-countdown]');
  function tick() {
    const now = Date.now();
    cds.forEach((el) => {
      const end = Date.parse(el.dataset.tmCountdown); let d = Math.max(0, Math.floor((end - now) / 1000));
      if (d <= 0) { const o = el.closest('[data-tm-offer]'); if (o) o.hidden = true; return; }
      const dd = Math.floor(d / 86400); d %= 86400; const h = Math.floor(d / 3600); d %= 3600; const m = Math.floor(d / 60); const s = d % 60;
      const p = (n) => String(n).padStart(2, '0');
      if (el.dataset.style === 'boxes') el.innerHTML = `<span><b>${p(dd)}</b>giorni</span><span><b>${p(h)}</b>ore</span><span><b>${p(m)}</b>min</span><span><b>${p(s)}</b>sec</span>`;
      else el.textContent = `${dd}g ${p(h)}:${p(m)}:${p(s)}`;
    });
  }
  if (cds.length) { tick(); setInterval(tick, 1000); }

  /* Page panier : synchronise les cadeaux puis recharge si besoin */
  if (document.body.classList.contains('tm--cart')) {
    getCart().then(syncGifts).then((c) => { if (c._changed) location.reload(); const gb = $('[data-tm-gifts]'); if (gb) gb.innerHTML = giftBar(c._sub || 0); });
  }

  /* Bandeau rotatif */
  $$('[data-tm-rotate]').forEach((bar) => {
    const items = $$('.tm-rot', bar); if (items.length < 2) return;
    let i = items.findIndex((x) => x.classList.contains('is-on')); if (i < 0) i = 0;
    setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4200);
  });
  /* Avant / après */
  $$('[data-tm-ba]').forEach((el) => {
    const r = $('.tm-ba__range', el);
    r.addEventListener('input', () => el.style.setProperty('--pos', r.value + '%'));
  });

  /* Fiche produit */
  const pdp = $('[data-tm-pdp]');
  if (pdp) {
    const variants = JSON.parse($('[data-tm-variants]', pdp).textContent);
    const form = $('[data-tm-form]', pdp);
    const vid = $('[data-tm-vid]', pdp);
    const fs = $$('[data-tm-opt]', pdp);
    const sel = {};
    const current = variants.find((v) => v.id === +vid.value) || variants[0];
    current.options.forEach((o, i) => { sel[i + 1] = o; });

    function match() { return variants.find((v) => v.options.every((o, i) => o === sel[i + 1])); }
    function refreshPills() {
      const prim = fs.length ? +fs[0].dataset.tmOpt : 1;
      fs.forEach((f) => {
        const pos = +f.dataset.tmOpt;
        $$('.tm-pill', f).forEach((p) => {
          const val = p.dataset.tmVal;
          p.classList.toggle('is-on', val === sel[pos]);
          if (pos === prim) {
            p.hidden = false;
            p.classList.toggle('is-na', !variants.some((v) => v.options[pos - 1] === val && v.available));
          } else {
            const ex = variants.filter((v) => v.options[pos - 1] === val && v.options[prim - 1] === sel[prim]);
            p.hidden = ex.length === 0;
            p.classList.toggle('is-na', ex.length > 0 && !ex.some((v) => v.available));
          }
        });
        const lab = $('[data-tm-optval]', f); if (lab) lab.textContent = tr(sel[pos]);
      });
    }
    function apply(v) {
      if (!v) return;
      vid.value = v.id;
      $('[data-tm-price]', pdp).textContent = money(v.price);
      $('[data-tm-atc-price]', pdp).textContent = money(v.price);
      const sp = $('[data-tm-sticky-price]', pdp); if (sp) sp.textContent = money(v.price);
      const c = $('[data-tm-compare]', pdp); const s = $('[data-tm-save]', pdp);
      if (v.compare > v.price) { c.hidden = false; c.textContent = money(v.compare); s.hidden = false; s.textContent = 'Risparmi ' + money(v.compare - v.price); }
      else { c.hidden = true; s.hidden = true; }
      const atc = $('[data-tm-atc]', pdp); atc.disabled = !v.available;
      $('[data-tm-atc-label]', pdp).textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito';
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }
    pdp.addEventListener('click', (e) => {
      const p = e.target.closest('.tm-pill'); if (!p) return;
      const pos = +p.closest('[data-tm-opt]').dataset.tmOpt;
      sel[pos] = p.dataset.tmVal;
      let v = match();
      if (!v) { // garde le choix cliqué, prend la 1re combinaison valide
        v = variants.find((x) => x.options[pos - 1] === sel[pos] && x.available) || variants.find((x) => x.options[pos - 1] === sel[pos]);
        if (v) v.options.forEach((o, i) => { sel[i + 1] = o; });
      }
      refreshPills(); apply(v);
    });
    refreshPills();

    /* Taille en barre segmentée + « Componi il tuo set » */
    const compose = $('[data-tm-compose]', pdp);
    const sizes = $$('[data-tm-size]', pdp);
    function composeTotal() {
      const sz = sizes.find((b) => b.classList.contains('is-on'));
      let base = sz ? +sz.dataset.price : (variants.find((x) => x.id === +vid.value) || {}).price || 0;
      const on = compose ? $$('.tm-combo.is-on', compose) : [];
      on.forEach((c) => { base += +c.dataset.price; });
      const n = 1 + on.length;
      const t1 = compose ? +compose.dataset.t1 : 0, t2 = compose ? +compose.dataset.t2 : 0;
      const pct = n >= 3 ? t2 : n >= 2 ? t1 : 0;
      const total = Math.round(base * (100 - pct) / 100);
      if (compose) {
        $$('[data-tm-tier]', compose).forEach((t) => t.classList.toggle('is-on', n >= +t.dataset.tmTier));
        const half = $('[data-tm-tier="2"] i', compose); if (half) half.style.width = n >= 2 ? '100%' : '35%';
        const full = $('[data-tm-tier="3"] i', compose); if (full) full.style.width = n >= 3 ? '100%' : n >= 2 ? '45%' : '0%';
      }
      $('[data-tm-atc-price]', pdp).textContent = money(total);
      const sp = $('[data-tm-sticky-price]', pdp); if (sp) sp.textContent = money(total);
      return { total, n, pct };
    }
    sizes.forEach((b) => b.addEventListener('click', () => {
      sizes.forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
      const v = variants.find((x) => x.id === +b.dataset.tmSize); if (v) apply(v);
      composeTotal();
    }));
    if (compose) {
      compose.addEventListener('click', (e) => {
        const c = e.target.closest('.tm-combo'); if (!c) return;
        c.classList.toggle('is-on'); c.setAttribute('aria-pressed', c.classList.contains('is-on'));
        composeTotal();
      });
    }
    if (sizes.length) { const d = sizes.find((b) => b.classList.contains('is-on')); if (d) { const v = variants.find((x) => x.id === +d.dataset.tmSize); if (v) apply(v); } composeTotal(); }
    const selOne = $('[data-tm-select]', pdp);
    if (selOne) selOne.addEventListener('change', () => { const v = variants.find((x) => x.options[0] === selOne.value); if (v) apply(v); });

    const setsel = $('[data-tm-setsel]', pdp);
    function currentSet() { const r = setsel && $('input[name="tm-set"]:checked', setsel); return r && r.value ? r : null; }
    function syncSetUI() {
      if (!setsel) return;
      $$('.tm-setopt', setsel).forEach((l) => l.classList.toggle('is-on', $('input', l).checked));
      const r = currentSet();
      const atcP = $('[data-tm-atc-price]', pdp); const lab = $('[data-tm-atc-label]', pdp);
      if (r) { atcP.textContent = money(+r.dataset.price); lab.textContent = 'Aggiungi il set'; }
      else { const v = variants.find((x) => x.id === +vid.value); atcP.textContent = money(v.price); lab.textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito'; }
      const sp = $('[data-tm-single-price]', pdp); const v2 = variants.find((x) => x.id === +vid.value); if (sp && v2) sp.textContent = money(v2.price);
    }
    if (setsel) { setsel.addEventListener('change', syncSetUI); pdp.addEventListener('click', (e) => { if (e.target.closest('.tm-pill')) setTimeout(syncSetUI, 0); }); }
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const cs = currentSet();
      const items = cs ? cs.value.split(',').filter(Boolean).map((x) => { const [id, q] = x.split(':'); return { id: +id, quantity: +(q || 1) }; }) : [{ id: +vid.value, quantity: 1 }];
      if (compose) $$('.tm-combo.is-on', compose).forEach((c) => items.push({ id: +c.dataset.tmCombo, quantity: 1 }));
      $$('[data-tm-addon]:checked', pdp).forEach((c) => items.push({ id: +c.value, quantity: 1 }));
      addItems(items, $('[data-tm-atc]', pdp));
    });

    // Galerie : compteur mobile
    const track = $('[data-tm-track]', pdp);
    const slides = $$('.tm-gal__slide', track);
    const tot = $('[data-tm-total-slides]', pdp); if (tot) tot.textContent = slides.length;
    const idx = $('[data-tm-idx]', pdp);
    if (track && idx) track.addEventListener('scroll', () => { idx.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1; }, { passive: true });

    // Barre d'achat collante
    const sticky = $('[data-tm-sticky]', pdp); const atc = $('[data-tm-atc]', pdp);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { const on = !en.isIntersecting && en.boundingClientRect.top < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); }).observe(atc);
      $('[data-tm-sticky-btn]', pdp).addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit')));
    }
  }
})();
